import React from 'react';
import { motion } from 'framer-motion';

import HeroSection      from '../components/sections/HeroSection';
import AboutSection     from '../components/sections/AboutSection';
import ServicesSection  from '../components/sections/ServicesSection';
import ApproachSection  from '../components/sections/ApproachSection';
import ContactSection   from '../components/sections/ContactSection';
import FAQSection       from '../components/sections/FAQSection';
import ResourcesSection from '../components/sections/ResourcesSection';

/* ╔══════════════════════════════════════════════════════════╗
   ║  HINTERGRUND-REIHENFOLGE                                 ║
   ║  false → 1-2-1-2-1-2-1  (weiß zuerst)                   ║
   ║  true  → 2-1-2-1-2-1-2  (beige/orange zuerst)           ║
   ╚══════════════════════════════════════════════════════════╝ */
const INVERT_BG = false; // ← hier umschalten

const A = INVERT_BG ? 'bg-page-2' : 'bg-page-1';
const B = INVERT_BG ? 'bg-page-1' : 'bg-page-2';

const HomePage = () => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.5 }}
  >
    <section id="home"      className={A}><HeroSection /></section>
    <section id="about"     className={`py-0 ${B}`}><AboutSection /></section>
    <section id="services"  className={`py-0 ${A}`}><ServicesSection /></section>
    <section id="approach"  className={`py-0 ${B}`}><ApproachSection /></section>
    <section id="contact"   className={`py-0 ${A}`}><ContactSection /></section>
    <section id="faq"       className={`py-0 ${B}`}><FAQSection /></section>
    <section id="resources" className={`py-0 ${A}`}><ResourcesSection /></section>
  </motion.div>
);

export default HomePage;